import { IssueDetailData } from '@/entities/issue/public';
import { IssueStatusType } from '@/ui/pages/issue/public/issueTypes';

export function intoSendable(issueRecordEditable: IssueDetailData): IssueStatusType {
  return {
    status: issueRecordEditable.status,
  };
}
